import script from "./HomePageAlignmentReportDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageAlignmentReportDialog.vue?vue&type=script&setup=true&lang=js"

import "./HomePageAlignmentReportDialog.vue?vue&type=style&index=0&id=3164293c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3164293c"]])

export default __exports__